import { parseQuery } from '@calendly/http-tools'

import { sanitizePaneProps } from './sanitize_props'

export const parseState = (state) => {
  try {
    if (state) {
      const paneStateQs = atob(state)
      if (paneStateQs) {
        const rawProps = parseQuery(paneStateQs)
        return [false, sanitizePaneProps(rawProps)]
      }
    }
  } catch (e) {
    return [e, {}]
  }
  return [false, {}]
}
